export default __webpack_public_path__ + "static/media/Ellipse 8.548bc22e.png";